module.exports = __webpack_public_path__ + "img/solution5.5556c6da.png";